import React from 'react'

interface AuditLogsIconProps {
    size?: string
    color?: string
}

export default function AuditLogsIcon({ size="20", color="#79808A" }: AuditLogsIconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.11666 14.7166C7.20736 15.8073 8.64253 16.4861 10.1776 16.6372C11.7127 16.7883 13.2527 16.4024 14.5351 15.5453C15.8176 14.6882 16.7631 13.413 17.2106 11.9368C17.6582 10.4607 17.58 8.87501 16.9894 7.45006C16.3988 6.02511 15.3323 4.84905 13.9718 4.12229C12.6112 3.39553 11.0408 3.16305 9.528 3.46447C8.01524 3.76589 6.65381 4.58255 5.67572 5.77528C4.69762 6.96802 4.16339 8.46302 4.16406 10.0055V11.484" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M2.5 9.44965L4.05556 10.8385L5.61111 9.44965M10.2778 6.67188V10.1441H14.1667" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

    )
}